import { units } from '@m/alchemy-ui';
import styled from 'styled-components';

export const HeaderText = styled.p`
  margin-bottom: ${units(1)};
`;
